module.exports = __webpack_public_path__ + "static/epasa-3272f49e3f9fe37f11076f866d892833.png";